export default {
    computed: {
        'ui': function () {
            return {
                isDark: this.$store.getters['persist/layout/isDark']
            }
        }
    }
};